import React from 'react';

import { 
  Box,
  Text
} from '@chakra-ui/react';

import { TableMembros } from '../Table';

export const InfoPessoa = (props) => {
  const { name, data, columns } = props;

  return (
    <Box 
      display="block"
      style={{
        pageBreakInside: 'avoid'
      }}
    >
      <Text
        fontWeight={700}
        fontSize="12px"
        lineHeight="21.6px"
        color="#797A80"
        mt="15px"
      >
        {name}
      </Text>
      <TableMembros
        data={data} 
        columns={columns} 
      /> 
    </Box>
  );
}